"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultMeetingReadinessChecker = createDefaultMeetingReadinessChecker;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
function createDefaultMeetingReadinessChecker(meetingSession, logger) {
  return new _amazonChimeSdkJs.DefaultMeetingReadinessChecker(logger, meetingSession, {
    timeoutMs: 20000
  });
}